import HtmlElement from './HtmlElement';
import SwiperSlider from './SwiperSlider';
import { $window, Breakpoints } from '../Constants'

/**
 * BigImageText
 *
 * @return Array
 */
const BigImageText = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		BIG_IMAGE_TEXT: '.big-image-text',
		IMAGE_SLIDER: '.big-image-text-image-slider',
		PAGINATION: '.swiper-pagination'
	};

	/**
	 * BigImageText
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class BigImageText extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this._$imageSlider = this.$element.find(Selector.IMAGE_SLIDER);
			this.wasVideoRepositioned = false;

			if (this._$imageSlider.length) {
				this._initializeImageSlider();
			}

			if (this.$element.hasClass('has-video')) {
				this.$videoWrap = this.$element.find('.big-image-text-video');
				this.$imageColumn = this.$element.find('.big-image-text-image-column');
				this._handleVideo();
			}
		}

		// Private

		_initializeImageSlider() {
			const slider = new SwiperSlider(this._$imageSlider);

			slider.setOptions({
				slidesPerView: 1,
				effect: 'fade',
				grabCursor: true,
				pagination: {
					el: Selector.PAGINATION,
					clickable: true
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				}
			});

			slider._initialize();
		}

		_getBreakpointsOfClasses() {
			const classes = ['xsmall', 'medium', 'xmedium', 'large', 'xlarge', 'xxlarge'];
			const classesOfSection = [...this.$element.get(0).classList].filter(str => str.match('big-image-text-columns-', 'i'));
			const breakpoints = {};

			classesOfSection.forEach((classOfSection, i) => {
				const breakpointPart = classOfSection.split('big-image-text-columns-')[1];
				const columns = breakpointPart.split(`${classes[i]}-`)[1];
				breakpoints[classes[i]] = columns !== '12-12';
			});

			return breakpoints;
		}

		_handleVideo() {
			this._handleVideoRepositioning();

			$window.on('resize', () => {
				this._handleVideoRepositioning();
			});
		}

		_handleVideoRepositioning() {
			const breakpoints = this._getBreakpointsOfClasses();
			const winW = $window.width();

			if (winW >= Breakpoints.X_SMALL && winW < Breakpoints.MEDIUM) {
				this._repositionVideo(breakpoints.xsmall);
			} else if (winW >= Breakpoints.MEDIUM && winW < Breakpoints.X_MEDIUM) {
				this._repositionVideo(breakpoints.medium);
			} else if (winW >= Breakpoints.X_MEDIUM && winW < Breakpoints.LARGE) {
				this._repositionVideo(breakpoints.xmedium);
			} else if (winW >= Breakpoints.LARGE && winW < Breakpoints.X_LARGE) {
				this._repositionVideo(breakpoints.large);
			} else if (winW >= Breakpoints.X_LARGE && winW < Breakpoints.XX_LARGE) {
				this._repositionVideo(breakpoints.xlarge);
			} else if (winW >= Breakpoints.XX_LARGE) {
				this._repositionVideo(breakpoints.xxlarge);
			}
		}

		_repositionVideo(breakpoint) {
			if (breakpoint) {
				if (!this.wasVideoRepositioned) {
					this.$videoWrap.prependTo(this.$element);
					this.wasVideoRepositioned = true;
				}
			} else {
				if (this.wasVideoRepositioned) {
					this.$videoWrap.prependTo(this.$imageColumn);
					this.wasVideoRepositioned = false;
				}
			}
		}
	}

	return BigImageText._getElements(Selector.BIG_IMAGE_TEXT, BigImageText);
})();

export default BigImageText;
